module.exports = __webpack_public_path__ + "img/handset-ptt.ec88a94a.webp";